import { render, staticRenderFns } from "./UIReview.vue?vue&type=template&id=66e862fa&scoped=true&"
import script from "./UIReview.vue?vue&type=script&lang=js&"
export * from "./UIReview.vue?vue&type=script&lang=js&"
import style0 from "./UIReview.vue?vue&type=style&index=0&id=66e862fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e862fa",
  null
  
)

export default component.exports